export const useWetickets = () => ({
  head: [
    {
      dataField: 'name',
      label: '',
    },
    {
      dataField: 'fullPrice',
      label: 'Preț',
    },
    {
      dataField: "discount",
      label: 'Early Bird',
    },
    {
      dataField: 'buyTicket',
      label: '',
    },
  ],
  data: [
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Conference Pass: WeImagine'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '990 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '790 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Ana și Daniel Dumbravă'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '800 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '600 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Norbert Gubincsik'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '500 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: 'GRATUIT'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Elena Haralabaki'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1200 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '740 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Victor Lax'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '2460 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '1720 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Ovidiu Leșan'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1100 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '800 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Cafa Liu'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '2460 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '1720 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Julius Paul'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '700 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '500 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Marian Sterea'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '800 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '600 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Florin Ștefan'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '750 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '500 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'PACHET Conference Pass WeImagine + Workshop Victor Lax'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '2960 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '2200 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'PACHET Conference Pass WeImagine + Workshop Cafa Liu'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '2960 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '2200 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
  ]
});